import LoadingLine from '../../Custom/LoadingLine';

export default function NavigationLoadingLine({ busy = false }) {
    return <LoadingLine busy={busy} />;
}
